// extracted by mini-css-extract-plugin
module.exports = {"menu":"MobileNavigation_menu__1gELO","btn":"MobileNavigation_btn__YDYx1"};